import React, { PureComponent } from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import InputGroup from '../../../components/Form/InputGroup';
import Alert from '../../../components/Form/Alert';
import { Input } from '../../../components/Form';
import Addresses from './Addresses';
import Accounts from './Accounts';
import { createValidator, required, minLength, maxLength, collectionValidator } from '../../../components/Form/validators';


class CompanyForm extends PureComponent {
  constructor(props) {
    super(props);
    this.toggleVatPayer = this.toggleVatPayer.bind(this);
    this.state = {
      notVatPayer: false
    }
  }

  toggleVatPayer(e) {
    this.setState({
      notVatPayer: e.target.checked
    })
  }

  render() {
    const { notVatPayer } = this.state;
    const { handleSubmit, invalid, error, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        {error && <Alert>{error}</Alert>}
        <fieldset className="form-group">
          <legend>Pamatinformācija</legend>
          <Field component={Input} name="name" label="Nosaukums" />
          <Field component={Input} name="registrationNumber" label="Reģistrācijas numurs" />
          { !notVatPayer && <Field component={Input} name="vatNumber" label="PVN numurs" /> }
          <InputGroup label="Nav PVN maksātājs" id="toggleVatPayer">
            <div className="form-check">
              <label className="form-check-label">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="toggleVatPayer"
                  checked={notVatPayer}
                  onClick={this.toggleVatPayer}
                />
              </label>
            </div>
          </InputGroup>
        </fieldset>

        <FieldArray name="addresses" component={Addresses} />
        <FieldArray name="accounts" component={Accounts} />

        <button 
          className="btn pull-right btn-primary btn-lg"
          disabled={invalid || submitting }
          type="submit"
        >
          Turpināt
        </button>
      </form>
    )
  }
}

const addressValidator = createValidator({
  type: required,
  address: [required, minLength(6), maxLength(256)]
});

const accountValidator = createValidator({
    bank: required,
    number: [required, maxLength(128)]
});
const validate = createValidator({
  name: [required, minLength(3), maxLength(64)],
  registrationNumber: [required, minLength(4), maxLength(64)],
  vatNumber: [minLength(4), maxLength(64)],
  addresses: collectionValidator(addressValidator),
  accounts: collectionValidator(accountValidator)
});

export default reduxForm({
  form: 'register_company',
  validate
})(CompanyForm);


// WEBPACK FOOTER //
// ./src/scenes/Registration/CompanyForm/index.js